<template>
    <div class="currency-container">
        <primevue-select
            v-model="selectedCurrency"
            :options="options"
            optionLabel="name"
            optionValue="id"
            placeholder="Select a currency"
        />
        <div class="action-buttons">
            <primevue-button label="Reset" @click="reset" />
        </div>
    </div>
</template>

<script setup lang="ts">
import PrimevueButton from 'primevue/button';
import PrimevueSelect from 'primevue/select';
import { computed } from 'vue';
import { useDataStore } from '@/stores/powerMarkets/dataStore.ts';
import { IIdName } from '@/interfaces/general/IIdName.ts';

const defaultCurrency: IIdName = { id: 'default', name: 'Default' };

const props = defineProps<{
    modelValue: null | string;
}>();

const emit = defineEmits<{
    'update:modelValue': [string];
}>();

const dataStore = useDataStore();

function reset (): void {
    selectedCurrency.value = defaultCurrency.id;
}

const selectedCurrency = computed({
    get () {
        if (!props.modelValue) {
            return defaultCurrency.id;
        }
        const foundCurrency = options.value.find((option) => option.id === props.modelValue);
        return foundCurrency?.id ?? defaultCurrency.id;
    },
    set (newValue: string): void {
        emit('update:modelValue', newValue);
    },
});

const options = computed(() => {
    const optionsArray: Array<IIdName> = [defaultCurrency];
    Object.entries(dataStore.staticStore.currencies).forEach(([key, value]) => {
        optionsArray.push({ id: key, name: `${value.prefix} ${value.suffix}` });
    });

    return optionsArray;
});

</script>

<style lang="scss" scoped>
.currency-container {
    padding: var(--defaultSpacing);
    display: grid;
    grid-template-columns: 100px auto;
    gap: var(--defaultSpacing);

    .y-axis-action-buttons {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
